import { createContext, useState } from "react";
import axios from 'axios'
import { useRef } from "react";
import { Artista } from "../controllers/ArtistsController";
import { Cancion } from "../controllers/SongsController";
import { Pueblo } from "../controllers/VillagesController";
import { Voto } from "../controllers/VotesController";
import { Usuario } from "../controllers/UsersController";
import { Datos } from "../controllers/DatasController";

export const ContextApp = createContext();

export const AppProvider = ({ children }) => {

    const token = useRef('');
    const expireIn = useRef('90');
    const [user, setUser] = useState(
        {
            nombre: "",
            password: "",
        }
    );

    const decades = ['50', '60', '70', '80', '90', '00','10','20'];
    const niveles = ['1', '2', '3', '4', '5'];

    const bdaxios = axios.create({
        baseURL: process.env.REACT_APP_BASEURL,
    });

    const artista = new Artista();
    const cancion = new Cancion();
    const pueblo = new Pueblo();
    const voto = new Voto();
    const usuario = new Usuario();
    const datos = new Datos();

    const loginUp = async (userData) => {
        try {
            const res = await bdaxios({
                method: 'POST',
                url: '/login',
                data: userData,
                withCredentials: true,
            });

            setUser(userData)
            token.value = res.data.token;
            expireIn.value = res.data.expireIn;
            await refreshToken();
            return token
        } catch (error) {
            // console.log(error)
            return (error)
        }
    }
    const logOut = async () => {
        try {
            sessionStorage.clear();
            const res = await bdaxios({
                method: 'GET',
                url: '/logout',
            })
            console.log(res.data)
            token.value = ''
        } catch (error) {
            throw new Error('Error RefreshToken')
        } finally {
            resetStore()
        }
    }
    const resetStore = () => {
        setUser('')
        token.value = null;
        expireIn.value = null;
    }
    const refreshToken = async () => {
        try {
            const res = await bdaxios({
                method: 'GET',
                url: '/refresh',
                withCredentials: 'true',
            })
            token.value = res.data.token;
            expireIn.value = res.data.expiresIn;
        } catch (error) {
            token.value = ''
            expireIn.value = ''
            setTime()
        }
    }
    const setTime = () => {
        setInterval(async () => {
            if (token.value!=='') {
                await refreshToken()
                if (token.value === '') window.location.pathname=('/')
                
            }
        }, 800 * 1000);
    }


    setTime()

    return (
        <ContextApp.Provider value={{
            bdaxios,
            decades,
            niveles,
            loginUp,
            logOut,
            refreshToken,
            user,
            setUser,
            token,
            artista,
            cancion,
            pueblo,
            voto,
            usuario,
            datos,
        }}>
            {children}
        </ContextApp.Provider>
    )
}